module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Sign Solutions of Ohio","short_name":"Sign Solutions","description":"Your Local, Trusted Sign Company","start_url":"/","background_color":"#ffffff","theme_color":"#2563eb","display":"standalone","icon":"src/images/favicon.png","icons":[{"src":"src/images/favicon-192.png","sizes":"192x192","type":"image/png"},{"src":"src/images/favicon-512.png","sizes":"512x512","type":"image/png"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"ba63dd5fc1149cb022db33cb807a16c9"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
